import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { cloneDeep } from "lodash-es";
import { Observable } from "rxjs";

import { DataProtectionConfigService } from "../data-protection.config";

import {
	Consents,
	ConsentsResponse,
	ConsentsResponseV2,
	MarketingSettings,
	MarketingSettingsWithTokenRequest,
} from "./marketing-settings.model";

@Injectable()
export class MarketingSettingsService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: DataProtectionConfigService
	) {}

	getConsents(): Observable<ConsentsResponse> {
		return this.httpClient.get<ConsentsResponse>({ url: this.config.getMarketingSettingsEndpoint() });
	}

	/*
	 * TODO: Remove this temporary endpoint when every question are clarified.
	 * NOTE: Till that time, to avoid cumbersome and painful interface and code modifications,
	 * this separated endpoint is used for Marketing Consent Reneval in LoginForm service.
	 */
	getConsentsV2(): Observable<ConsentsResponseV2> {
		return this.httpClient.get<ConsentsResponseV2>({ url: this.config.getMarketingSettingsEndpointV2() });
	}

	updateMarketingSettings(data: MarketingSettings): Observable<MarketingSettings> {
		return this.httpClient.patch({ url: this.config.getMarketingSettingsEndpoint(), data });
	}

	updateConsents(consents: Partial<Consents>): Observable<object> {
		return this.httpClient.patch({
			url: this.config.getMarketingSettingsEndpoint(),
			data: { consents },
		});
	}

	updateMarketingSettingsWithToken(data: MarketingSettingsWithTokenRequest): Observable<MarketingSettings> {
		// todo: remove this once API either accepts `null` or `undefined`,
		// or until we reach an agreement on how this will be handled
		const updateData: MarketingSettingsWithTokenRequest = cloneDeep(data);

		updateData.consents = {
			// The value `cookie` is required to be `undefined` to support post registration flow
			// similar to brand marketing below, we need to have the cookie undefined in case
			// the rest below are defined for the post registration page to show
			cookie: data.consents.cookie,
			groupMarketing: data.consents.groupMarketing,
			// The value `brandMarketing` is required to be `undefined` to support post registration flow
			// An `undefined` value signals the API to ignore the value and not overwrite it
			brandMarketing: data.consents.brandMarketing,
			thirdParty: data.consents.thirdParty || false,
		};

		if (data.subscriptions) {
			updateData.subscriptions = {
				acceptEmailOffers: data.subscriptions.acceptEmailOffers || false,
				acceptSmsOffers: data.subscriptions.acceptSmsOffers || false,
				acceptTelesalesOffers: data.subscriptions.acceptTelesalesOffers || false,
			};
		}

		return this.httpClient.post({
			url: this.config.getMarketingSettingsEndpoint(),
			data: updateData,
		});
	}
}
